import React from "react"
import { CloseIcon } from "components/SVG"
import {
  drawerHeadline,
  closeButton,
  shadeSelectorHeader,
} from "./ShadeSelectorModal.css"

export type Props = {
  onCloseModal: React.Dispatch<React.SetStateAction<boolean>>
  children: React.ReactNode
  styleVariant?: "default" | "stickyHeader"
}

export const ShadeSelectorHeader: React.FC<Props> = ({
  onCloseModal,
  styleVariant = "default",
  children,
}) => {
  const toggleDrawer = () => {
    onCloseModal(false)
  }

  return (
    <div className={`${shadeSelectorHeader[styleVariant]}`}>
      <button
        className={closeButton}
        onClick={toggleDrawer}
        type="button"
        tabIndex={0}
        aria-label="Close"
      >
        <CloseIcon width="20px" />
      </button>
      <h2 className={drawerHeadline}>{children}</h2>
    </div>
  )
}
